import type { DependencyContainer } from 'tsyringe';
import { IAIExplorerStreamSourceToken } from './AIExplorerStreamSource';
import { WebSocketAIExplorerStreamSource } from './WebSocketAIExplorerStreamSource';

/**
 * Binds the dashboard stream source to the websocket implementation. The view
 * models (AIExplorerViewModel, AIExplorerTileViewModel) are transient and resolve
 * automatically via tsyringe, so only the interface token needs binding. Swap
 * the bound source to retarget the stream transport.
 */
export function registerAIExplorer(container: DependencyContainer): void {
    container.register(IAIExplorerStreamSourceToken, { useClass: WebSocketAIExplorerStreamSource });
}
